import { Check } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { TrustStats } from "@/sections/TrustStats";
import { FoundersSection } from "@/sections/HomeTrust";
import { FinalCta } from "@/sections/HomeVoice";
import { useLanguage } from "@/i18n/LanguageContext";
import { IMAGES } from "@/data/images";

export default function About() {
  const { t } = useLanguage();
  const points = ["about.p1", "about.p2", "about.p3", "about.p4", "about.p5", "about.p6", "about.p7"];
  return (
    <>
      <PageHero eyebrow={t("about.eyebrow")} title={t("about.title")} sub={t("about.body")} image={IMAGES.site1} />
      <section className="bg-white py-24 md:py-32" data-testid="about-story">
        <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 md:px-8 lg:grid-cols-2">
          <Reveal>
            <img src={IMAGES.site1} alt="D & N Constructions team at a construction site" loading="lazy"
              className="aspect-[4/3] w-full rounded-2xl object-cover" />
          </Reveal>
          <Reveal delay={0.12}>
            <h2 className="font-display text-3xl text-charcoal md:text-4xl">Your home. Your choices. Our expertise.</h2>
            <p className="mt-6 text-base leading-relaxed text-charcoal/70">
              For over a decade, D & N Constructions has helped families across Tumakuru and Bengaluru turn ideas
              into homes. With 50+ completed projects — from independent houses and villas to G+6 buildings,
              commercial spaces and renovations — we bring the same care to every site: honest estimates,
              quality materials and communication you can count on.
            </p>
            <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {points.map((p) => (
                <li key={p} className="flex items-center gap-2.5 text-sm font-semibold text-charcoal/80">
                  <Check className="h-4 w-4 shrink-0 text-gold-dark" /> {t(p)}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>
      <TrustStats />
      <FoundersSection />
      <FinalCta />
    </>
  );
}
